import $ from "jquery"
const selector = '[data-close-attr]';
const activeClass: string = 'is-active'

export class ClickHandler {
	constructor() {
		document.addEventListener('click', this.hideOnClickOutside)
	}

	private hideOnClickOutside = (e: Event) => {
		if (!$(e.target).closest(selector).length) {
			if ($(selector).is(':visible')) {
				$(selector).removeClass(activeClass);
			}
		}
	}

	// get siblings helper function

	//private getSiblings = (elem) => {
	//	let siblings = [];
	//	let sibling = elem.parentNode.firstChild;
	//	for (; sibling; sibling = sibling.nextSibling) {
	//		if (sibling.nodeType !== 1 || sibling === elem) continue;
	//		siblings.push(sibling);
	//	}
	//	return siblings;
	//}

	//private hideOnClickOutside = () => {
	//	document.addEventListener("click", (event) => {
	//		const popElement: NodeList = document.querySelectorAll("[data-close-attr]");
	//		let videoModalToggleArray: HTMLElement[] = Array.prototype.slice.call(popElement);
	//		console.log("videoModalToggleArray", videoModalToggleArray);
	//		let isClickInside;
	//		videoModalToggleArray.forEach((elem) => {
	//			isClickInside = elem.contains(event.target as HTMLElement);
	//			console.log("elem", elem);
	//		});
	//		if (isClickInside) {
				
	//			console.log("Clicked inside one of the divs.", isClickInside);
		
	//		} else {
	//			console.log("Clicked outside of the divs.");
	//		}
	//	});

	//}
}


